import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { Checkbox } from "primereact/checkbox";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../Base/Components/Card/Card";
import { useForm } from "../../../Base/Hooks/useForm";
import { toastShow } from "../../../Base/Services/ToastService";
import { AuthContext } from "../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../Base/Components/Loader/Loader";
import { getDateTimeStringSQL } from "../../../Base/Services/Moment/Luxon";
import ModalFull from "../../../Base/Components/Dialog/ModalFull";

// ------------------- CONSULTAS A LA API---------------------------
import { getTiposIngreso, ObtenerSiguienteNoIngreso } from "../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { asignarCuentaEnTransito, cambiarExcentoDet, EditarIngreso, EditarIngresoSINPO, EliminarItemIngreso, getOrdenesEnTransito, GuardarIngreso, GuardarIngresoSINPO, ObtenerDetalleIngresos } from "../../../API/Suministros/IngresosBodega/IngresosBodegaDetalleRequest";
import { ObtenerEncabezadoIngresos } from "../../../API/Suministros/IngresosBodega/IngresosBodegaEncabezadoRequest";
import { getProveedorAct } from "../../../API/Compras/Proveedores/ProveedoresRequest";
import { getTasaCambio } from "../../../API/CalendarioOperativo/CalendarioOperativoRequest";
import { getBandejasActivas, getBodegasAct, getEstantesAct, getPosicionesAct } from "../../../API/Suministros/SuministrosRequest";
import { getEstadosCategory } from "../../../API/Global/Status/StatusRequests";
import { getTermTypePaymentTerms } from "../../../API/Compras/Terms/TermsRequest";
import { getProveedorCAIporVendor } from "../../../API/Compras/Proveedores/ProveedoresCAIRequest";
import { getCharAccountConcatProveedores, getCuentasHijosQuick } from "../../../API/Finanzas/RegistroContable/RegistroContableRequest";
import { getConstruccionesConcatenadas } from "../../../API/Global/Construcciones/ConstruccionesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import EncabezadoIngresos from "./EncabezadoIngresos";
import IngresosOverlayPanelDetalle from "../../ERP/Suministros/Bodegas/IngresosBodega/OverlayPanels/IngresosOverlayPanelDetalle";
import ProductosOverlayPanel from "../../ERP/Compras/Requisas/CrudRequisa/OverlayPanels/ProductoOverlayPanel";
import { ValidarFacturaProveedor } from "../../ERP/Compras/Proveedores/FuncionesProveedores";
import OrdenesComprasCrud from "../../ERP/Compras/OrdenesCompras/CrudOrdenesCompras/OrdenesComprasCrud";
import LotesOverlayPanel from "../../ERP/Suministros/Bodegas/IngresosBodega/OverlayPanels/LotesOverlayPanel";
import ModalCuentasEnTransito from "./ModalCuentasEnTransito";


const RegistroFactrasCRUD = ({
  idIngreso,
  setIngresoToShow = () => {},
  actualizarIngresosScreen = () => {},
  actualizarIngresosScreenListado = () => {},
  listadoDet,
  habilitar,
  setHabilitar,
  MateriaPrima,
  Servicios,
  reg
}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [detalles, setDetalles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proveedor, setProveedor] = useState([]);
  const [proveedorCAI, setProveedorCAI] = useState([]);
  const [selected, setSelected] = useState([]);
  const [NoIngreso, setNoIngreso] = useState([]);
  const [term, setTerm] = useState([]);
  const [tasaC, setTasaC] = useState([]);
  const [hab, setHab] = useState(false); // HABILITAR BOTON DE COMPONENTE SIN PO
  const [showPOColumn, setShowPOColumn] = useState(true);
  const [bodegas, setBodegas] = useState([]);
  const [estantes, setEstantes] = useState([]);
  const [posicion, setPosicion] = useState([]);
  const [bandeja, setBandeja] = useState([]);

  const [selectedBodega, setSelectedBodega] = useState(null);
  const [selectedEstante, setSelectedEstante] = useState(null);
  const [selectedPosicion, setSelectedPosicion] = useState(null);
  const [selectedBandeja, setSelectedBandeja] = useState(null); 
  const [filteredEstantes, setFilteredEstantes] = useState(estantes);
  const [filteredPosiciones, setFilteredPosiciones] = useState(posicion);
  const [filteredBandejas, setFilteredBandejas] = useState(bandeja);
  const [resBand, setResBand] = useState(false);
  const [resPos, setResPos] = useState(false);
  const [resEst, setResEst] = useState(false);

  const [ordenDialog, setOrdenDialog] = useState(false)
  const [orderToShow, setOrderToShow] = useState(false)
  const [requisaDialog, setRequisaDialog] = useState(false)
  const [checkDollar, setCheckDollar] = useState(false);
  const [tiposIngreso, setTiposIngreso] = useState([]);

  const [verCostos, setVerCostos] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(49) || userAuth.IdRol == 1);
  const [hiddenPriceColumn, setHiddenPriceColumn] = useState(userAuth.AccessWeb.split(",").map((e) => parseInt(e)).includes(29));
  const [verCostosBodega, setVerCostosBodega] = useState(false);
  const [isMateriaPrima, setIsMateriaPrima] = useState(false);
  const [listEstados, setListEstados] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [cuentas2, setCuentas2] = useState([]);
  const [dialogTransito, setDialogTransito] = useState(false);
  const [desdeDropdown, setDesdeDropdown] = useState(false);
  const [dataTransito, setDataTransito] = useState(true);
  const [serviciosNuevo, setServiciosNuevo] = useState(Servicios);
  const [construcciones, setConstrucciones] = useState([]);

  //   PARA ENCABEZADO EL VALUES
  const initialValues = {
    FechaIngreso: new Date(),
    UsuarioIngreso: userAuth.Usuario,
    IdEstado: 23,
    StatusName: "Ingresado",
    IdIngreso: -1,
    NumeroIngreso: idIngreso ? idIngreso : "",
    FechaFactura: new Date(),
    OCE: null
  };

  const { values, setValues, handleInputChange, handleChange, resetForm } = useForm(initialValues);

  // OBTENER INFORMACION PARA LOS DROPDAWN
  const getInfo = async () => {
    setLoading(true);
    setIsMateriaPrima(MateriaPrima) 

    const supplier = await getProveedorAct();
    setProveedor(supplier);

    const termTempo = await getTermTypePaymentTerms()
    setTerm(termTempo)

    const bodegasTempo = await getBodegasAct()
    setBodegas(bodegasTempo)

    const estantesTempo = await getEstantesAct()
    setEstantes(estantesTempo)

    const posicionesTempo = await getPosicionesAct()
    setPosicion(posicionesTempo)

    const bandejasTempo = await getBandejasActivas()
    setBandeja(bandejasTempo)

    const tiposIngresoTempo = await getTiposIngreso()
    setTiposIngreso(tiposIngresoTempo)

    const estadosTempo = await getEstadosCategory('IngresosBodega')
    setListEstados(estadosTempo?.filter(i=> i?.IdStatus === 74 || i?.IdStatus === 75))

    const cuentasTempo = await getCharAccountConcatProveedores()
    setCuentas(cuentasTempo)

    const cuentasTempo2 = await getCuentasHijosQuick()
    setCuentas2(cuentasTempo2)

    const construccionesTempo = await getConstruccionesConcatenadas()
    setConstrucciones(construccionesTempo)

    setLoading(false);
  };

  const obtenerCAI = async (IdVendor) => {
    const CAITempo = await getProveedorCAIporVendor(IdVendor)

    if(CAITempo.length>0){
      setProveedorCAI(CAITempo)
    }else{
      setProveedorCAI([])
      setValues({
        ...values,
        NombreSucursal: '',
        IdProveedorCAI: null,
        OCE: null
      })
    }
  }

  // OBTENER VALORES INICIALES PARA CREAR UNA NUEVO INGRESO
  const getInfoNew = async () => {
    setLoading(true);
    let DatosEncabezado = {
      IdTipoIngreso: 3
    }

    setServiciosNuevo(true)

    const NIngreso = await ObtenerSiguienteNoIngreso(DatosEncabezado);
    setNoIngreso(NIngreso);

    const calendarioMensual = await getTasaCambio()
    setTasaC(calendarioMensual)

    let d = {
        ...values,
        IdIngreso: -100,
        NumeroIngreso: NIngreso[0].NumeroIngreso,
        TasaCambio: calendarioMensual[0]?.TasaCambio,
        IdBodega: null,
        NombreBodega: '',
        IdTipoIngreso: 3,
        Inventario: 'Servicios',
        OCE:null
    };

    setTimeout(() => {
      setValues(d);
    }, 300);
    setLoading(false);
  };

  // OBTENER PARA EDITAR UN INGRESO
  const obtenerIngreso = async (ingreso) => {
    setLoading(true);

    let req = ingreso ? ingreso : values;

    const detallesTempo = await ObtenerDetalleIngresos(req.NumeroIngreso);
    setDetalles(detallesTempo);

    const calendarioMensual = await getTasaCambio()
    setTasaC(calendarioMensual)

    setHab(true)
    const t = await ObtenerEncabezadoIngresos(req.NumeroIngreso);

    if(t[0]?.IdTipoIngreso === 3){
      setServiciosNuevo(true)
    }else{
      setServiciosNuevo(false)
    }

    if((t[0]?.IdCuenta === 15 || t[0]?.IdCuenta === 14) && t[0]?.IdTipoIngreso !== 3){
      if(!t[0]?.IdCuentaTransito){
        const dataTransito = await getOrdenesEnTransito(t[0]?.IdPurchaseOrder)
        if(dataTransito?.length > 0){
          toastShow(toast, 'warn', 'Advertencia','La orden de compra tiene cuenta en transito')
          setDataTransito(dataTransito)
          setDialogTransito(true)
        }
      }
    }

    // setEncabezado(t);
    if (t.length > 0) {
      const [detailIngresos] = t;
      const n = {
        ...detailIngresos,
        FechaIngreso: new Date(detailIngresos.FechaIngreso),
        // TasaCambio: calendarioMensual[0]?.TasaCambio,
        FechaFactura: new Date(detailIngresos?.FechaFactura),
        OCE:detailIngresos?.OCE,
        NombreSucursal: detailIngresos?.NombreSucursal,
      };
      setCheckDollar(detailIngresos?.IsDollar)
      setIsMateriaPrima(detailIngresos?.IsMateriaPrima)
      setValues(n);
      setIngresoToShow(detailIngresos.NumeroIngreso);
      setHabilitar(false);

      if(!n?.IdPurchaseOrder){
        setShowPOColumn(false)
      }else{

        setShowPOColumn(true)
      }
    } else {
      const d = {
        ...initialValues,
        NumeroIngreso: values.NumeroIngreso,
        Factura: null,
        Comentarios: null,
        TasaCambio: calendarioMensual[0]?.TasaCambio,
        OCE: null
      };
      setValues(d);
      setDetalles([]);
      toastShow(
        toast,
        "error",
        "Error",
        "No se encontro el Ingreso."
      );
      setHab(false)
      // setShowPOColumn(true)
      setHabilitar(true);
    }
    setLoading(false);
  };

  // AGREGAR NUEVA FILA
  const agregarNuevaFila = () => {
    let newRowData = [...detalles];
    let IdDet = -(detalles?.length +  1)

    let index = -1 * parseInt((+new Date().getTime() + "").substring(9, 14));
    const newData = {
      IdIngresoDetalle: IdDet,
      IdPurchaseOrderDetail: null,
      FechaIngreso: new Date(),
      IdEstado: 23,
      StatusName: "Ingresado",
      PurchaseOrder: "",
      NombreProducto: "",
      NombreTipoProducto: "",
      Currency: "",
      TAX: 0,
      IdCategory: 0,
      IdCurrency: null,
      IdProduct: null,
      IdVendor: null,
      IdBodega: null,
      IdEstante: null,
      IdPosicion: null,
      IdSubCategory: null,
      IdTipoIngreso: null,
      IdUnit: null,
      IdUserEdit: null,
      Usuario: "",
      UserName: "",
      NombreCategoria: "",
      NombreSubcategoria: "",
      NombreBodega: "",
      NombreEstante: "",
      NombrePosicion: "",
      FechaCierre: "",
      Precio: 0,
      Ingreso: 0,
      CustomerName: "",
      Quantity: 0,
      QtyReceive: 0,
      SubTotal: 0,
      Total: 0,
      TAX: 0,
      ISV: 0,
      Descuento: 0,
      TipoProducto: "",
      UnitName: "",
      Inventario: 0,
      Descripcion: "",
      PrecioL: 0,
      MontoL:0,
      PrecioD:0,
      MontoD:0,
      TasaCambio:values.TasaCambio,
      CostoL:0,
      CostoD:0,
      IdBodega: 0,
      NombreBodega: "",
      IdEstante: 0,
      NombreEstante: "",
      IdPosicion: 0,
      NombrePosicion:"",
      IdBandeja: null,
      NombreBandeja: "",
      EmbalajeL: 0,
      EmbalajeD: 0,
      DesaduanajeL: 0,
      DesaduanajeD: 0,
      FleteL: 0,
      FleteD: 0,
      OtrosCostosL: 0,
      OtrosCostosD: 0,
      IdLote: null,
      NoLote: "",
      NoLoteInt: "",
      CustomerName: "",
      IdUnit: null,
      UnitName: "",
      // FechaObsoleto: ''
    };

    if (newRowData.length > 0) {
      const lastRow = newRowData[newRowData.length - 1];
      if (lastRow && (lastRow.IdPurchaseOrderDetail || lastRow.IdProduct)) {
        newRowData.push(newData);
      } else {
        newRowData[newRowData.length - 1] = newData;
      }
    }else{
      newRowData.push(newData);
    }

  setDetalles(newRowData);
  };

  // ACTUALIZAR INGRESOS
  const actualizarIngresos = async (NoIngreso) => {
    setLoading(true);
    const d = await ObtenerDetalleIngresos(
      NoIngreso ? NoIngreso : values.NumeroIngreso
    );
    setDetalles(d);
    setLoading(false);
  };

  // AGREGAR PRODUCTO
  const changePO = ({ data }) => {
    let selectProveedor = values.CustomerName?.IdVendor;
    return (
      <IngresosOverlayPanelDetalle
        isMateriaPrima={isMateriaPrima}
        selectProveedor={selectProveedor}
        IdProveedor={values.IdProveedor ? values?.IdProveedor : values?.IdVendor}
        rowData={data}
        onChange={({ api, data }, rowData) => {

          const index = detalles.findIndex((detail) => detail.IdIngresoDetalle === rowData.IdIngresoDetalle);
          const isAlreadyAdded = detalles.some((detail) => detail.IdPurchaseOrderDetail === data.IdPurchaseOrderDetail);
          const isPurchaseOrderDifferent = detalles.length === 0 || detalles.every((detail) => !detail.PurchaseOrder || detail.PurchaseOrder === data.PurchaseOrder);

          if (isAlreadyAdded) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "El detalle de orden de compra seleccionada ya esta agregada en este ingreso"
            );
            return;
          }

          if (!isPurchaseOrderDifferent) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "No se permite agregar detalles de diferentes ordenes de compras."
            );
            return; // Detener la ejecución si el PurchaseOrder es diferente
          }

          let newDetail = [...detalles];
          newDetail[index].PurchaseOrder = data.PurchaseOrder;
          newDetail[index].IdPurchaseOrderDetail = data.IdPurchaseOrderDetail;
          newDetail[index].IdCategory = data.IdCategoria;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].IdSubCategory = data.IdSubCategoria;
          newDetail[index].IdTipoProducto = data.IdTipoProducto;
          newDetail[index].IdTipoIngreso = data.IdType;
          newDetail[index].IdCurrency = data.IdCurrency;
          newDetail[index].UnitPrice = data.UnitPrice;
          newDetail[index].Discount = data.Discount;
          newDetail[index].Descripcion = data.Description;
          newDetail[index].IdProduct = data.IdComponent;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].IdVendor = null;
          newDetail[index].CustomerName = null;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitSimbol;
          newDetail[index].Type = data.Type;
          newDetail[index].IdBodega = data.IdBodega;
          newDetail[index].NombreBodega = data.NombreBodega;
          newDetail[index].IdEstante = data.IdEstante;
          newDetail[index].NombreEstante = data.NombreEstante;
          newDetail[index].IdPosicion = data.IdPosicion;
          newDetail[index].NombrePosicion = data.NombrePosicion;
          newDetail[index].IdBandeja = data.IdBandeja;
          newDetail[index].NombreBandeja = data.NombreBandeja;
          newDetail[index].Currency = data.Currency;
          newDetail[index].UserName = data.UserNameAgente;
          newDetail[index].Usuario = data.Usuario;
          newDetail[index].Quantity = data.Quantity;
          newDetail[index].QtyReceive = data.QtyReceive;
          newDetail[index].ISV = data.TAX;
          newDetail[index].Precio = data?.IdCurrency === 1 ? data?.UnitPrice * values?.TasaCambio : data?.UnitPrice;
          newDetail[index].PrecioD = data?.IdCurrency === 1 ? data?.UnitPrice : data?.UnitPrice / values?.TasaCambio 
          newDetail[index].Balance = data?.Quantity - data?.QtyReceive;
          newDetail[index].ISVProducto = data?.TAX / data?.Quantity
          newDetail[index].ISVProductoL = 0
          newDetail[index].DescuentoProducto = data?.Discount / data?.Quantity
          newDetail[index].EmbalajeL = 0
          newDetail[index].EmbalajeD = 0
          newDetail[index].DesaduanajeL = 0
          newDetail[index].DesaduanajeD = 0
          newDetail[index].FleteL = 0
          newDetail[index].FleteD = 0
          newDetail[index].OtrosCostosL = 0
          newDetail[index].OtrosCostosD = 0
          newDetail[index].NoSacos = 0


          setSelectedBandeja(data)
          setSelectedPosicion(data)
          setSelectedEstante(data)
          setSelectedBodega(data)
          
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const validarDetalle = (detalle, isMateriaPrima) => {
    // if (detalle.IdBodega === null && reg) return "Debes ingresar la bodega en todos los detalles.";
    // if (detalle.IdEstante === null && reg) return "Debes ingresar el estante en todos los detalles.";
    // if (detalle.IdPosicion === null && reg) return "Debes ingresar la fila en todos los detalles.";
    // if (detalle.IdBandeja === null && reg) return "Debes ingresar la bandeja en todos los detalles.";
    // if ((detalle.IdLote === undefined || detalle.IdLote === null) && isMateriaPrima) return "El lote es requerido en los detalles para materia prima.";
    // if (detalle.NoSacos === 0 && isMateriaPrima) return "Debe ingresar cantidad de sacos.";
    return null;
  };

  // AGREGAR PRODUCTO
  const changeProducto = ({ data }) => {
    return (
      <ProductosOverlayPanel
        MateriaPrima={isMateriaPrima}
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdIngresoDetalle === rowData.IdIngresoDetalle
          );

          const isAlreadyAdded = detalles.some(
            (detail) =>
              detail.IdProduct === data.IdProduct
          );

          if (isAlreadyAdded) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "Ya existe el producto en este ingreso"
            );
            return;
          }

          // console.log(data) // PRODUCTO
          // console.log(detalles) //INGRESO ACTUAL

          // console.log(data)

          let newDetail = [...detalles];
          newDetail[index].IdCategory = data.IdCategoria;
          newDetail[index].CodigoProducto = data.CodigoProducto;
          newDetail[index].IdSubCategory = data.IdSubCategoria;
          newDetail[index].IdTipoProducto = data.IdTipoProducto;
          newDetail[index].IdTipoIngreso = data.IdType;
          newDetail[index].IdCurrency = data.IdCurrency;
          newDetail[index].UnitPrice = data.UnitPrice;
          newDetail[index].Discount = data.Discount;
          newDetail[index].Descripcion = data.DescripcionProducto;
          newDetail[index].IdProduct = data.IdProduct;
          newDetail[index].NombreProducto = data.NombreProducto;
          newDetail[index].NombreTipoProducto = data.NombreTipoProducto;
          newDetail[index].IdVendor = null;
          newDetail[index].CustomerName = null;
          newDetail[index].NombreCategoria = data.NombreCategoria;
          newDetail[index].NombreSubcategoria = data.NombreSubcategoria;
          newDetail[index].IdUnit = data.IdUnit;
          newDetail[index].UnitName = data.UnitSimbol;
          newDetail[index].IdBodega = data.IdBodega;
          newDetail[index].NombreBodega = data.NombreBodega;
          newDetail[index].IdEstante = data.IdEstante;
          newDetail[index].NombreEstante = data.NombreEstante;
          newDetail[index].IdPosicion = data.IdPosicion;
          newDetail[index].NombrePosicion = data.NombrePosicion;
          newDetail[index].IdBandeja = data.IdBandeja;
          newDetail[index].NombreBandeja = data.NombreBandeja;
          newDetail[index].Currency = data.Currency;
          newDetail[index].Quantity = data.Quantity;
          newDetail[index].QtyReceive = data.QtyReceive;
          newDetail[index].Price = 0;
          newDetail[index].ISVProductoL = 0;
          newDetail[index].Descuento = 0;
          newDetail[index].MontoL = 0;
          newDetail[index].MontoD = 0;
          newDetail[index].DescuentoD = 0;
          newDetail[index].EmbalajeL = 0
          newDetail[index].EmbalajeD = 0
          newDetail[index].DesaduanajeL = 0
          newDetail[index].DesaduanajeD = 0
          newDetail[index].FleteL = 0
          newDetail[index].FleteD = 0
          newDetail[index].OtrosCostosL = 0
          newDetail[index].OtrosCostosD = 0


          // console.log(newDetail)
          



          setSelectedBandeja(data)
          setSelectedPosicion(data)
          setSelectedEstante(data)
          setSelectedBodega(data)

          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const addOC = (infoOrden) => {

    const allPurchaseOrders = new Set([
      ...detalles.map((item) => item.PurchaseOrder),
      ...infoOrden.map((item) => item.PurchaseOrder),
    ]);
  
    if (allPurchaseOrders.size > 1) {
      toastShow(toast, "error", "Error", "No se permiten detalles de órdenes diferentes.");
      return;
    }
  
    const OrdenExistente = detalles.some((i) => infoOrden.some((f) => f.IdIngreso === i.IdDetalleRef && f.PurchaseOrder === i.PurchaseOrder));
  
    if (OrdenExistente) {
      toastShow(toast, "error", "Error", "No se permiten valores repetidos.");
    } else {
      let dataNueva = [];

      infoOrden.forEach((f) => {
        let Id = (detalles.length + dataNueva.length + 1) * -1;
        let Precio = f.IdCurrency === 1 ? f.UnitPrice * values?.TasaCambio : f.UnitPrice;
        let PrecioD = f.IdCurrency === 1 ? f.UnitPrice : f.UnitPrice / values?.TasaCambio;

        let ISVProducto = f?.TAX / f?.Quantity;
        let ISV18Producto = f?.ISV18 / f?.Quantity;
        let DescuentoProducto = f?.Discount / f?.Quantity;

        dataNueva.push({
          IdIngresoDetalle: Id,
          PurchaseOrder: f.PurchaseOrder,
          IdPurchaseOrderDetail: f.IdPurchaseOrderDetail,
          IdProduct: f.IdComponent,
          IdCategory: f.IdCategoria,
          IdSubCategory: f.IdSubCategoria,
          IdTipoProducto: f.IdTipoProducto,
          IdTipoIngreso: f.IdType,
          IdCurrency: f.IdCurrency,
          Descripcion: f.Description,
          NombreProducto: f.NombreProducto,
          NombreTipoProducto: f.NombreTipoProducto,
          NombreCategoria: f.NombreCategoria,
          NombreSubcategoria: f.NombreSubcategoria,
          IdUnit: f.IdUnit,
          UnitName: f.UnitSimbol,
          Type: f.Type,
          IdBodega: f.IdBodega,
          NombreBodega: f.NombreBodega,
          IdEstante: f.IdEstante,
          NombreEstante: f.NombreEstante,
          IdPosicion: f.IdPosicion,
          NombrePosicion: f.NombrePosicion,
          Currency: f.Currency,
          UserName: f.UserNameAgente,
          Usuario: f.Usuario,
          Quantity: f.Quantity,
          QtyReceive: f.QtyReceive,
          Precio,
          PrecioD,
          ISV: f.TAX,
          ISV18Producto,
          Ingreso: serviciosNuevo ? 0 : f.Balance,
          Balance: serviciosNuevo ? 0 : f.Balance,
          CantidadReservada: serviciosNuevo ? f.BalanceReservado : 0,
          BalanceReservado: serviciosNuevo ? f.BalanceReservado : 0,
          FechaIngreso: new Date(),
          IdEstado: 23,
          StatusName: "Ingresado",
          TasaCambio: values.TasaCambio,
          CodigoProducto: f.CodigoProducto,
          IdBandeja: f.IdBandeja,
          NombreBandeja: f.NombreBandeja,
          ISVProducto,
          DescuentoProducto,
          NoSacos: 0,
        });
      });
  
      let nuevoArreglo = [...detalles, ...dataNueva];

      nuevoArreglo = nuevoArreglo.map((data) => {
        const SubTotal = data.IdCurrency === 1 ? (data.Precio * data.Ingreso) * data.TasaCambio : data.Precio * data.Ingreso;
        const SubTotalD = data.IdCurrency === 1 ? data.Precio * data.Ingreso : (data.Precio * data.Ingreso) / data.TasaCambio;  
        const ISVProductoL = data.IdCurrency === 1 ? (data.ISVProducto * data.TasaCambio) * data.Ingreso : data.ISVProducto * data.Ingreso; 
        const ISVProductoD = data.IdCurrency === 1 ? data.ISVProducto * data.Ingreso : (data.ISVProducto / data.TasaCambio) * data.Ingreso;  

        const ISV18ProductoL = data.IdCurrency === 1 ? (data.ISV18Producto * data.TasaCambio) * data.Ingreso : data.ISV18Producto * data.Ingreso; 
        const ISV18ProductoD = data.IdCurrency === 1 ? data.ISV18Producto * data.Ingreso : (data.ISV18Producto / data.TasaCambio) * data.Ingreso;  


        const Descuento = data.IdCurrency === 1 ? (data.DescuentoProducto * data.TasaCambio)* data.Ingreso : data.DescuentoProducto * data.Ingreso;  
        const DescuentoD = data.IdCurrency === 1 ? data.DescuentoProducto * data.Ingreso: (data.DescuentoProducto / data.TasaCambio) * data.Ingreso;
        const MontoL = SubTotal + ISVProductoL - Descuento + ISV18ProductoL;
        const MontoD = SubTotalD + ISVProductoD - DescuentoD + ISV18ProductoD;
        const CostoL = MontoL;
        const CostoD = MontoD;
  
        return {
          ...data,
          SubTotal,
          SubTotalD,
          ISVProductoL,
          ISVProductoD,
          ISV18ProductoL,
          ISV18ProductoD,
          Descuento,
          DescuentoD,
          MontoL,
          MontoD,
          CostoL,
          CostoD
        };
      });
      setDetalles(nuevoArreglo);
      setSelectedBandeja(nuevoArreglo);
      setSelectedPosicion(nuevoArreglo);
      setSelectedEstante(nuevoArreglo);
      setSelectedBodega(nuevoArreglo);
    }
  };

  const addSingleOC = (infoOrden) => {
    let IdOrdenDetailQueViene = infoOrden.data?.IdPurchaseOrderDetail
    let encuentraIdEnDetalles = detalles.find(i => i?.IdPurchaseOrderDetail === IdOrdenDetailQueViene)
    
    if (!infoOrden || infoOrden.length === 0) return;

    if(encuentraIdEnDetalles){
      toastShow(toast, 'warn', 'Advertencia','La orden que desea agregar ya existe en este ingreso.')
      return
    }

    
    const detalle = infoOrden?.data;   
    let Id = (detalles.length + 1) * -1;
    let Precio = detalle.IdCurrency === 1 ? detalle.UnitPrice * values?.TasaCambio : detalle.UnitPrice;
    let PrecioD = detalle.IdCurrency === 1 ? detalle.UnitPrice : detalle.UnitPrice / values?.TasaCambio;
    let ISVProducto = detalle?.TAX / detalle?.Quantity;
    let ISV18Producto = detalle?.ISV18 / detalle?.Quantity;

    let DescuentoProducto = detalle?.Discount / detalle?.Quantity;
  
    let nuevoDetalle = {
      IdIngresoDetalle: Id,
      PurchaseOrder: detalle.PurchaseOrder,
      IdPurchaseOrderDetail: detalle.IdPurchaseOrderDetail,
      IdProduct: detalle.IdComponent,
      IdCategory: detalle.IdCategoria,
      IdSubCategory: detalle.IdSubCategoria,
      IdTipoProducto: detalle.IdTipoProducto,
      IdTipoIngreso: detalle.IdType,
      IdCurrency: detalle.IdCurrency,
      Descripcion: detalle.Description,
      NombreProducto: detalle.NombreProducto,
      NombreTipoProducto: detalle.NombreTipoProducto,
      NombreCategoria: detalle.NombreCategoria,
      NombreSubcategoria: detalle.NombreSubcategoria,
      IdUnit: detalle.IdUnit,
      UnitName: detalle.UnitSimbol,
      Type: detalle.Type,
      IdBodega: detalle.IdBodega,
      NombreBodega: detalle.NombreBodega,
      IdEstante: detalle.IdEstante,
      NombreEstante: detalle.NombreEstante,
      IdPosicion: detalle.IdPosicion,
      NombrePosicion: detalle.NombrePosicion,
      Currency: detalle.Currency,
      UserName: detalle.UserNameAgente,
      Usuario: detalle.Usuario,
      Quantity: detalle.Quantity,
      QtyReceive: detalle.QtyReceive,
      Precio,
      PrecioD,
      ISV: detalle.TAX,
      Ingreso: Servicios ? 0 : detalle.Balance,
      Balance: Servicios ? 0 : detalle.Balance,
      CantidadReservada: Servicios ? detalle.BalanceReservado : 0,
      BalanceReservado: Servicios ? detalle.BalanceReservado : 0,
      FechaIngreso: new Date(),
      IdEstado: 23,
      StatusName: "Ingresado",
      TasaCambio: values.TasaCambio,
      CodigoProducto: detalle.CodigoProducto,
      IdBandeja: detalle.IdBandeja,
      NombreBandeja: detalle.NombreBandeja,
      ISVProducto,
      ISV18Producto,
      DescuentoProducto,
      NoSacos: 0,
    };
  
    // Cálculos adicionales
    const SubTotal = nuevoDetalle.IdCurrency === 1 ? (nuevoDetalle.Precio * nuevoDetalle.Ingreso) * nuevoDetalle.TasaCambio : nuevoDetalle.Precio * nuevoDetalle.Ingreso;
    const SubTotalD = nuevoDetalle.IdCurrency === 1 ? nuevoDetalle.Precio * nuevoDetalle.Ingreso : (nuevoDetalle.Precio * nuevoDetalle.Ingreso) / nuevoDetalle.TasaCambio;
    const ISVProductoL = nuevoDetalle.IdCurrency === 1 ? (nuevoDetalle.ISVProducto * nuevoDetalle.TasaCambio) * nuevoDetalle.Ingreso : nuevoDetalle.ISVProducto * nuevoDetalle.Ingreso;
    const ISVProductoD = nuevoDetalle.IdCurrency === 1 ? nuevoDetalle.ISVProducto * nuevoDetalle.Ingreso : (nuevoDetalle.ISVProducto / nuevoDetalle.TasaCambio) * nuevoDetalle.Ingreso;
    const ISV18ProductoL = nuevoDetalle.IdCurrency === 1 ? (nuevoDetalle.ISV18Producto * nuevoDetalle.TasaCambio) * nuevoDetalle.Ingreso : nuevoDetalle.ISV18Producto * nuevoDetalle.Ingreso;
    const ISV18ProductoD = nuevoDetalle.IdCurrency === 1 ? nuevoDetalle.ISV18Producto * nuevoDetalle.Ingreso : (nuevoDetalle.ISV18Producto / nuevoDetalle.TasaCambio) * nuevoDetalle.Ingreso;
    const Descuento = nuevoDetalle.IdCurrency === 1 ? (nuevoDetalle.DescuentoProducto * nuevoDetalle.TasaCambio) * nuevoDetalle.Ingreso : nuevoDetalle.DescuentoProducto * nuevoDetalle.Ingreso;
    const DescuentoD = nuevoDetalle.IdCurrency === 1 ? nuevoDetalle.DescuentoProducto * nuevoDetalle.Ingreso : (nuevoDetalle.DescuentoProducto / nuevoDetalle.TasaCambio) * nuevoDetalle.Ingreso;
    const MontoL = SubTotal + ISVProductoL - Descuento;
    const MontoD = SubTotalD + ISVProductoD - DescuentoD;
    const CostoL = MontoL;
    const CostoD = MontoD;
  
    nuevoDetalle = {
      ...nuevoDetalle,
      SubTotal,
      SubTotalD,
      ISVProductoL,
      ISVProductoD,
      ISV18ProductoL,
      ISV18ProductoD,
      Descuento,
      DescuentoD,
      MontoL,
      MontoD,
      CostoL,
      CostoD,
    };
  
    const nuevoArreglo = [...detalles, nuevoDetalle];
  
    setDetalles(nuevoArreglo);
    setSelectedBandeja(nuevoArreglo);
    setSelectedPosicion(nuevoArreglo);
    setSelectedEstante(nuevoArreglo);
    setSelectedBodega(nuevoArreglo);
  };

  // GUARDAR O EDITAR INGRESOS
  const guardarIngresosBodega = async (valor, IdUserRevisoFin) => {  
    const validarFactura = await ValidarFacturaProveedor(values)
    if(!validarFactura?.Valido && (values?.CustomerName?.IdCountry === 95 || values?.IdCountry === 95)){
      toastShow(
        toast,
        "warn",
        "Advertencia",
        validarFactura?.Mensaje
      );
    }
      // SIN PO
    let guardar = true;
    if (detalles.length === 0) {
      toastShow( toast, "error", "Error al guardar", "Debe seleccionar al menos una orden de compra.");
      guardar = false;
    } else {
      detalles.forEach((d) => {
        if (d.Ingreso === 0) {
          toastShow( toast, "error", "Error al guardar", "La cantidad debe ser mayor a 0.");
          guardar = false;
        }
      });
    }


    if(values?.IdTipoIngreso === 1){
      for (const d of detalles) {
        const error = validarDetalle(d, isMateriaPrima);
        if (error) {
          toastShow(toast, "error", "Error al guardar", error);
          guardar = false;
          break;
        }
      }
    }


    const tieneExento = detalles.some((d) => d.IsExento === true);

    // Verificar si todos los detalles son exentos
    const todosSonExentos = detalles.every((d) => d.IsExento === true);
    
    // Verificar si al menos un detalle tiene ISV
    const tieneISV = detalles.some((d) => d?.ISVProductoL);
    const tieneISV18 = detalles.some((d) => d?.ISV18ProductoL);
    
    // Si hay un exento y al menos un detalle que no es exento y no hay OCE, mostrar el toast
    if (tieneExento && !todosSonExentos && !tieneISV && !tieneISV18) {
      toastShow(toast, "error", "Error al guardar", "Debe ingresar OCE.");
      return;
      }

    if (guardar) {
      setLoading(true);
      setHabilitar(true);


      const encabezado = {
        IdIngreso: values.IdIngreso,
        NumeroIngreso: values.NumeroIngreso,
        IdVendor: values.CustomerName?.IdVendor || values?.IdVendor,
        IdUserIngreso: userAuth.IdUser,
        FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
        Factura: values.Factura,
        IdUsuarioEdit: userAuth.IdUser,
        Comentarios: values.Comentarios,
        IdEstado: values.IdEstado,
        IdUsuarioEdit: userAuth.IdUser,
        TasaCambio: values.TasaCambio,
        IdTerm: values?.Term?.IdTerm ? values?.Term?.IdTerm  : values?.IdTerm,
        FechaFactura: getDateTimeStringSQL(values?.FechaFactura),
        IdProveedorCAI: values?.NombreSucursal?.IdProveedorCAI || values?.IdProveedorCAI,
        IdTipoIngreso: values?.IdTipoIngreso,

        Embalaje: values?.Embalaje,
        Desaduanaje: values?.Desaduanaje,
        Flete: values?.Flete,
        OtrosCostos: values?.OtrosCostos,

        TasaCambioEmbalaje: values?.TasaCambioEmbalaje,
        TasaCambioDesaduanaje: values?.TasaCambioDesaduanaje,
        TasaCambioFlete: values?.TasaCambioFlete,
        TasaCambioOtrosCostos: values?.TasaCambioOtrosCostos,
        IsDollar: checkDollar === true ? 1 : 0,
        IsMateriaPrima: isMateriaPrima === true ? 1: 0,
        OCE: values?.OCE,
        IdEstadoRevisado: valor ? 75 : (values?.EstadoRevisado?.IdStatus || values?.IdEstadoRevisado),
        IdCuenta: values?.IdAccount || values?.IdCuenta,
      };

      const detallesIngreso = detalles.map((detalle) => {
        return {
          ...detalle[0],
          IdIngresoDetalle: detalle.IdIngresoDetalle,
          IdIngreso: values.IdIngreso,
          // IdPurchaseOrderDetail: null,
          IdProduct: detalle.IdProduct,
          IdCategory: detalle.IdCategory,
          IdSubCategory: detalle.IdSubCategory,
          IdTipoProducto: detalle.IdTipoProducto,
          IdEstado: detalle.IdEstado,
          FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
          Descripcion: detalle.Descripcion,
          IdTipoIngreso: values?.IdTipoIngreso,
          IdCurrency: detalle.IdCurrency,
          IdUnit: detalle.IdUnit,
          IdEstante: detalle.IdEstante,
          IdPosicion: detalle.IdPosicion,
          // FechaCierre: detalle.FechaCierre,
          IdUsuarioEdit: userAuth.IdUser,
          Ingreso: detalle.Ingreso,
          Precio: detalle.Precio,
          ISV: detalle.ISV,
          TasaCambio: values.TasaCambio,
          IdBodega: detalle?.IdBodega,
          IdEstante: detalle?.IdEstante,
          IdPosicion: detalle?.IdPosicion,
          IdBandeja: detalle?.IdBandeja,

          ISVProductoL: detalle?.ISVProductoL,
          ISVProductoD: detalle?.ISVProductoD,

          ISV18ProductoL: detalle?.ISV18ProductoL,
          ISV18ProductoD:  detalle?.ISV18ProductoD,
          
          Descuento: detalle?.Descuento,
          DescuentoD: detalle?.DescuentoD,
          SubTotal: detalle?.SubTotal,
          SubTotalD: detalle?.SubTotalD,

          MontoL: detalle?.MontoL,
          MontoD: detalle?.MontoD,

          CostoL: detalle?.CostoL,
          CostoD: detalle?.CostoD,

          EmbalajeL: detalle?.EmbalajeL,
          EmbalajeD: detalle?.EmbalajeD,
          DesaduanajeL: detalle?.DesaduanajeL,
          DesaduanajeD: detalle?.DesaduanajeD,
          FleteL: detalle?.FleteL,
          FleteD: detalle?.FleteD,
          OtrosCostosL: detalle?.OtrosCostosL,
          OtrosCostosD: detalle?.OtrosCostosD,


          PrecioUL: detalle?.PrecioUL,
          PrecioUD: detalle?.PrecioUD,
          IdLote: detalle?.IdLote,
          NoSacos: detalle?.NoSacos,
          FechaObsoleto: detalle?.FechaObsoleto,
          IsExento: detalle?.IsExento,
          IdAccount: detalle?.IdAccount,
          IdSubConstruccion: detalle?.IdSubConstruccion,
          IdConstruccion: detalle?.IdConstruccion,
          IdUserRevisoFin: IdUserRevisoFin,
        }
      });

      if (encabezado?.IdIngreso > 0) {
        const respuestaDetalles = await EditarIngresoSINPO( encabezado, detallesIngreso);
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Editada", respuestaDetalles[0]?.MENSAJE);
          actualizarIngresos();
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow(toast, "error", "Error al editar", respuestaDetalles[0]?.MENSAJE);
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarIngresoSINPO( encabezado, detallesIngreso);
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow( toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);
          actualizarIngresos(respuestaDetalles[0]);
          obtenerIngreso(respuestaDetalles[0]);
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow( toast, "error", "Error al guardar", respuestaDetalles[0]?.MENSAJE);
          setLoading(false);
        }
      }
    }
  };
  
  const guardarIngresos = async (valor, IdUserRevisoFin) => {
    const validarFactura = await ValidarFacturaProveedor(values);
    if ( !validarFactura?.Valido && (values?.CustomerName?.IdCountry === 95 || values?.IdCountry === 95)) {
      toastShow(toast, "warn", "Advertencia", validarFactura?.Mensaje);
    }
    let guardar = true;

    if (detalles.length === 0) {
      toastShow( toast, "error", "Error al guardar", "Debe seleccionar al menos una orden de compra.");
      guardar = false;
    } else {
      detalles.forEach((d) => {
        if (d.PurchaseOrder === "" || d.IdPurchaseOrderDetail === 0) {
          toastShow( toast, "error", "Error al guardar", "Todos los items deben contener una orden de compra.");
          guardar = false;
        }
      });
    }
    const tieneExento = detalles.some((d) => d.IsExento === true);
    const todosSonExentos = detalles.every((d) => d.IsExento === true);
    const tieneISV = detalles.some((d) => d?.ISVProductoL);
    const tieneISV18 = detalles.some((d) => d?.ISV18ProductoL);

    if (tieneExento && !todosSonExentos && !tieneISV && !tieneISV18) {
      toastShow(toast, "error", "Error al guardar", "Debe ingresar OCE 222.");
      return;
    }
    if(dataTransito.length > 0){
      if(!values?.CuentaConcatenadaCont?.IdAccount){
        toastShow(toast, "error", "Error al guardar", "Seleccione la cuenta en Transito en el encabezado");
        guardar = false
      }
      if(values?.CuentaConcatenadaCont?.IdAccount === 14 || values?.CuentaConcatenadaCont?.IdAccount === 15 || values?.CuentaConcatenadaCont?.IdAccount === 14){
        toastShow(toast, "error", "Error al guardar", "Seleccione la cuenta en Transito en el encabezado");
        guardar = false
      }
    }

    if (guardar) {
      setLoading(true);
      const encabezado = {
        IdIngreso: values.IdIngreso,
        NumeroIngreso: values.NumeroIngreso,
        IdVendor: values.CustomerName?.IdVendor || values?.IdVendor,
        IdUserIngreso: userAuth.IdUser,
        FechaIngreso: getDateTimeStringSQL(new Date(values.FechaIngreso)),
        Factura: values.Factura,
        IdUsuarioEdit: userAuth.IdUser,
        Comentarios: values.Comentarios,
        IdEstado: values.IdEstado,
        IdUsuarioEdit: userAuth.IdUser,
        TasaCambio: values.TasaCambio,
        IdTerm: values?.Term?.IdTerm ? values?.Term?.IdTerm : values?.IdTerm,
        FechaFactura: getDateTimeStringSQL(values.FechaFactura),
        IdProveedorCAI: values?.NombreSucursal?.IdProveedorCAI || values?.IdProveedorCAI,
        IdTipoIngreso: values?.IdTipoIngreso,
        IdPurchaseOrder: values?.IdPurchaseOrder,
        Embalaje: values?.Embalaje,
        Desaduanaje: values?.Desaduanaje,
        Flete: values?.Flete,
        OtrosCostos: values?.OtrosCostos,
        TasaCambioEmbalaje: values?.TasaCambioEmbalaje,
        TasaCambioDesaduanaje: values?.TasaCambioDesaduanaje,
        TasaCambioFlete: values?.TasaCambioFlete,
        TasaCambioOtrosCostos: values?.TasaCambioOtrosCostos,
        IsDollar: checkDollar === true ? 1 : 0,
        IsMateriaPrima: isMateriaPrima === true ? 1 : 0,
        OCE: values?.OCE,
        IdEstadoRevisado: valor ? 75 : (values?.EstadoRevisado?.IdStatus || values?.IdEstadoRevisado),
        IdCuenta: values?.CuentaConcatenadaCont?.IdAccount || values?.IdCuenta || values?.IdAccount,
      };

      const detallesIngreso = detalles.map((detalle) => {
        return {
          ...detalle[0],
          IdIngresoDetalle: detalle.IdIngresoDetalle,
          IdIngreso: values.IdIngreso,
          IdPurchaseOrderDetail: detalle.IdPurchaseOrderDetail,
          IdProduct: detalle.IdProduct,
          IdCategory: detalle.IdCategory,
          IdSubCategory: detalle.IdSubCategory,
          IdTipoProducto: detalle.IdTipoProducto,
          IdEstado: detalle.IdEstado,
          Descripcion: detalle.Descripcion,
          IdTipoIngreso: values.IdTipoIngreso,
          IdCurrency: detalle.IdCurrency,
          IdUnit: detalle.IdUnit,
          IdEstante: detalle.IdEstante,
          IdPosicion: detalle.IdPosicion,
          FechaCierre: detalle.FechaCierre,
          IdUsuarioEdit: userAuth.IdUser,
          Ingreso: detalle.Ingreso,
          CantidadReservada: detalle.CantidadReservada,
          IdBodega: detalle?.IdBodega,
          IdEstante: detalle?.IdEstante,
          IdPosicion: detalle?.IdPosicion,
          IdBandeja: detalle?.IdBandeja,
          Precio: detalle.Precio,
          ISV: detalle.ISV,
          TasaCambio: values.TasaCambio,
          ISVProducto: detalle?.ISVProducto,
          DescuentoProducto: detalle?.DescuentoProducto,
          Total: detalle?.Total,
          ISVProductoL: detalle?.ISVProductoL,
          ISVProductoD: detalle?.ISVProductoD,
          ISV18ProductoL: detalle?.ISV18ProductoL,
          ISV18ProductoD: detalle?.ISV18ProductoD,
          Descuento: detalle?.Descuento,
          DescuentoD: detalle?.DescuentoD,
          SubTotal: detalle?.SubTotal,
          SubTotalD: detalle?.SubTotalD,
          MontoL: detalle?.MontoL,
          MontoD: detalle?.MontoD,
          CostoL: detalle?.CostoL,
          CostoD: detalle?.CostoD,
          EmbalajeL: detalle?.EmbalajeL,
          EmbalajeD: detalle?.EmbalajeD,
          DesaduanajeL: detalle?.DesaduanajeL,
          DesaduanajeD: detalle?.DesaduanajeD,
          FleteL: detalle?.FleteL,
          FleteD: detalle?.FleteD,
          OtrosCostosL: detalle?.OtrosCostosL,
          OtrosCostosD: detalle?.OtrosCostosD,
          PrecioUL: detalle?.PrecioUL,
          PrecioUD: detalle?.PrecioUD,
          IdLote: detalle?.IdLote,
          NoSacos: detalle?.NoSacos,
          FechaObsoleto: detalle?.FechaObsoleto,
          IsExento: detalle?.IsExento,
          IdAccount: detalle?.IdAccount,
          IdSubConstruccion: detalle?.IdSubConstruccion,
          IdConstruccion: detalle?.IdConstruccion,
          IdUserRevisoFin: IdUserRevisoFin || values?.IdUserRevisoFin,
        };
      });

      setLoading(false);

      console.log(encabezado)
      console.log(detalles)

      if (encabezado.IdIngreso > 0) {
        const respuestaDetalles = await EditarIngreso( encabezado, detallesIngreso);
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow(toast, "success", "Editada", respuestaDetalles[0]?.MENSAJE);
          actualizarIngresos();
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow( toast, "error", "Error al editar", respuestaDetalles[0]?.MENSAJE);
          setLoading(false);
        }
      } else {
        const respuestaDetalles = await GuardarIngreso(encabezado,detallesIngreso);
        if (respuestaDetalles[0].ESTADO !== -1) {
          setHabilitar(false);
          toastShow( toast, "success", "Guardado", respuestaDetalles[0]?.MENSAJE);
          actualizarIngresos(respuestaDetalles[0]);
          obtenerIngreso(respuestaDetalles[0]);
          actualizarIngresosScreen();
          actualizarIngresosScreenListado();
          obtenerIngreso();
          setLoading(false);
        } else {
          toastShow( toast, "error", "Error al guardar", respuestaDetalles[0]?.MENSAJE);
          setLoading(false);
        }
      }
    } else {
      setLoading(false);
    }
  };

  // ELIMINAR ITEM
  const eliminarItemDetalle = () => {
    if (selected.length > 0) {
      const algunDetalleNoValido = selected.some((detalle) => detalle?.Inventario < detalle?.Ingreso && detalle?.IdIngresoDetalle > 0);
      if (algunDetalleNoValido) {
        toastShow( toast, "error", "Error", "No se puede eliminar, ya existe una salida de este ingreso.");
      } else {
        confirmDialog({
          message: "Esta seguro que desea eliminar este item",
          header: "Cancelar",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Si",
          accept: () => cancelarDetalle(),
          rejectLabel: "No",
          style: { backgroundColor: "white" },
        });
      }
    } else {
      toastShow( toast, "warn", "Advertencia", "Seleccione un detalle de ingreso.");
    }
  };

  // ELIMINAR ITEM
  const cancelarDetalle = () => {
    selected.forEach(async (select) => {
      if (select.IdIngresoDetalle > 0) {
        if (select?.IdEstado !== 15) {
          const result = await EliminarItemIngreso(select);
          if (result[0]?.ESTADO === 1) {
            let tempo = [...detalles];
            selected.forEach((select) => {
              select.IdEstado = 26;
              select.StatusName = "Eliminado";
              select.Ingreso = 0;
              let f = tempo.findIndex((t) => t.IdIngresoDetalle === select.IdIngresoDetalle);
              tempo[f] = select;
            });
            setDetalles(tempo);
            setShowPOColumn(true)
            actualizarIngresosScreen();
          }
        } else {
          toastShow(toast,"error","Error","El Detalle de ingreso seleccionado ya está cancelado.");
        }
      } else {
        let tempo2 = detalles.filter((i) => !selected.some((e) => e.IdIngresoDetalle === i.IdIngresoDetalle));
        setDetalles(tempo2);
      }
    });
    setSelected([]);
  };

  const changeIngreso = ({ data, oldValue, column }) => {
    const index = detalles.findIndex((detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle);
    let newDetail = [...detalles];

    if(serviciosNuevo){
      if(showPOColumn){
        let sumaCantidad = data.QtyReceive + data?.CantidadReservada;
        if (column.colId === "CantidadReservada") {
          if (sumaCantidad > data.Quantity && data.IdIngresoDetalle < 0) {
            toastShow( toast, "error", "Error", "La cantidad ingresada es mayor que el balance de la Orden de Compra.");
            data.CantidadReservada = 0;
          } else if (data.IdIngresoDetalle > 0 && data.CantidadReservada > data.Quantity) {
            toastShow( toast, "error", "Error", "La cantidad ingresada es mayor que la cantidad de la orden de compra.");
            data.CantidadReservada = 0;
          } else {
            newDetail[index].CantidadReservada = data?.CantidadReservada;
          }
        }
  
        newDetail[index].SubTotal = data?.IdCurrency === 1 ? (data?.Precio * data?.CantidadReservada) * data?.TasaCambio : data?.Precio * data?.CantidadReservada
        newDetail[index].SubTotalD = data?.IdCurrency === 1 ? data?.Precio * data?.CantidadReservada : (data?.Precio * data?.CantidadReservada) / data?.TasaCambio
  
        newDetail[index].ISVProductoL = data?.IdCurrency === 1 ? (data?.ISVProducto * data?.TasaCambio) * data?.CantidadReservada : data?.ISVProducto * data?.CantidadReservada
        newDetail[index].ISVProductoD = data?.IdCurrency === 1 ? data?.ISVProducto * data?.CantidadReservada : (data?.ISVProducto /  data?.TasaCambio) * data?.CantidadReservada
  
        newDetail[index].ISV18ProductoL = data?.IdCurrency === 1 ? (data?.ISV18Producto * data?.TasaCambio) * data?.CantidadReservada : data?.ISV18Producto * data?.CantidadReservada
        newDetail[index].ISV18ProductoD = data?.IdCurrency === 1 ? data?.ISV18Producto * data?.CantidadReservada : (data?.ISV18Producto /  data?.TasaCambio) * data?.CantidadReservada
  
        
        newDetail[index].Descuento = data?.IdCurrency === 1 ? data?.DescuentoProducto * data?.TasaCambio : data?.DescuentoProducto * data?.CantidadReservada
        newDetail[index].DescuentoD = data?.IdCurrency === 1 ? data?.DescuentoProducto : data?.DescuentoProducto /  data?.TasaCambio 
  
        newDetail[index].MontoL = newDetail[index].SubTotal + newDetail[index].ISVProductoL - newDetail[index].Descuento;
        newDetail[index].MontoD = newDetail[index].SubTotalD + newDetail[index].ISVProductoD - newDetail[index].DescuentoD;
  
        newDetail[index].CostoL = newDetail[index].SubTotal + newDetail[index].ISVProductoL - newDetail[index].Descuento;
        newDetail[index].CostoD = newDetail[index].SubTotalD + newDetail[index].ISVProductoD - newDetail[index].DescuentoD;
        
        setDetalles(newDetail);
      }else{
        if (column.colId === "CantidadReservada") {
          newDetail[index].Ingreso = data?.CantidadReservada;
        }
        setDetalles(newDetail);
      }
    }else{
      if(showPOColumn){
        let sumaCantidad = data.QtyReceive + data.Ingreso;
        if (column.colId === "Ingreso") {
          if (sumaCantidad > data.Quantity && data.IdIngresoDetalle < 0) {
            toastShow( toast, "error", "Error", "La cantidad ingresada es mayor que el balance de la Orden de Compra.");
            data.Ingreso = 0;
          } else if (data.IdIngresoDetalle > 0 && data.Ingreso > data.Quantity) {
            toastShow( toast, "error", "Error", "La cantidad ingresada es mayor que la cantidad de la orden de compra.");
            data.Ingreso = 0;
          } else {
            newDetail[index].Ingreso = data?.Ingreso;
          }
        }
  
        newDetail[index].SubTotal = data?.IdCurrency === 1 ? (data?.Precio * data?.Ingreso) * data?.TasaCambio : data?.Precio * data?.Ingreso
        newDetail[index].SubTotalD = data?.IdCurrency === 1 ? data?.Precio * data?.Ingreso : (data?.Precio * data?.Ingreso) / data?.TasaCambio
  
        newDetail[index].ISVProductoL = data?.IdCurrency === 1 ? (data?.ISVProducto * data?.TasaCambio) * data?.Ingreso : data?.ISVProducto * data?.Ingreso
        newDetail[index].ISVProductoD = data?.IdCurrency === 1 ? data?.ISVProducto * data?.Ingreso : (data?.ISVProducto /  data?.TasaCambio) * data?.Ingreso
  
        newDetail[index].ISV18ProductoL = data?.IdCurrency === 1 ? (data?.ISV18Producto * data?.TasaCambio) * data?.Ingreso : data?.ISV18Producto * data?.Ingreso
        newDetail[index].ISV18ProductoD = data?.IdCurrency === 1 ? data?.ISV18Producto * data?.Ingreso : (data?.ISV18Producto /  data?.TasaCambio) * data?.Ingreso
  
        
        newDetail[index].Descuento = data?.IdCurrency === 1 ? data?.DescuentoProducto * data?.TasaCambio : data?.DescuentoProducto * data?.Ingreso
        newDetail[index].DescuentoD = data?.IdCurrency === 1 ? data?.DescuentoProducto : data?.DescuentoProducto /  data?.TasaCambio 
  
        newDetail[index].MontoL = newDetail[index].SubTotal + newDetail[index].ISVProductoL - newDetail[index].Descuento;
        newDetail[index].MontoD = newDetail[index].SubTotalD + newDetail[index].ISVProductoD - newDetail[index].DescuentoD;
  
        newDetail[index].CostoL = newDetail[index].SubTotal + newDetail[index].ISVProductoL - newDetail[index].Descuento;
        newDetail[index].CostoD = newDetail[index].SubTotalD + newDetail[index].ISVProductoD - newDetail[index].DescuentoD;
        
        setDetalles(newDetail);
      }else{
        if (column.colId === "Ingreso") {
          newDetail[index].Ingreso = data?.Ingreso;
        }
        setDetalles(newDetail);
      }
    }

    changePrecio({data}); 

  };

  const changePrecio = ({ data, oldValue, column }) => {
    const index = detalles.findIndex( (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle );
    
    let newDetail = [...detalles];

    if (!data.CodigoProducto) {
      toastShow( toast, "warn", "Advertencia", "Agregue el producto a ingresar." );
      resetDetail(index);
      return;
    }

    
    newDetail[index].PrecioD = data.Precio / data?.TasaCambio


    if(serviciosNuevo){      
      newDetail[index].SubTotal = data.Precio * data?.CantidadReservada
      newDetail[index].SubTotalD = data.PrecioD * data?.CantidadReservada
    }else{
      newDetail[index].SubTotal = data.Precio * data?.Ingreso
      newDetail[index].SubTotalD = data.PrecioD * data?.Ingreso
    }


    // newDetail[index].ISVProductoL = newDetail[index].SubTotal * 0.15
    newDetail[index].ISVProductoD = data?.ISVProductoL / data?.TasaCambio
    newDetail[index].ISV18ProductoD = data?.ISV18ProductoL / data?.TasaCambio


    newDetail[index].DescuentoD = data?.Descuento / data?.TasaCambio


    newDetail[index].MontoL = newDetail[index].SubTotal + data?.ISVProductoL - data?.Descuento
    newDetail[index].MontoD = newDetail[index].SubTotalD + (data?.ISVProductoL / data?.TasaCambio) - (data?.Descuento / data?.TasaCambio)

    newDetail[index].CostoL = newDetail[index].SubTotal + data?.ISVProductoL - data?.Descuento
    newDetail[index].CostoD = newDetail[index].SubTotalD + (data?.ISVProductoL / data?.TasaCambio) - (data?.Descuento / data?.TasaCambio)


    
    newDetail[index].EmbalajeL = 0;
    newDetail[index].EmbalajeD = 0;

    newDetail[index].DesaduanajeL = 0;
    newDetail[index].DesaduanajeD = 0;

    newDetail[index].FleteL = 0;
    newDetail[index].FleteD = 0;

    newDetail[index].OtrosCostosL = 0;
    newDetail[index].OtrosCostosD = 0;

    setDetalles(newDetail);



    function resetDetail(index) {
      newDetail[index].SubTotal = 0;
      newDetail[index].Descuento = 0;
      newDetail[index].ISV = 0;
      newDetail[index].Total = 0;
      newDetail[index].Precio = 0;
    }

  };

  const changeBodega = ({ data }) => {
    return (
      <div>
        <Dropdown
          value={selectedBodega}
          options={bodegas}
          style={{ width: "203px" }}
          optionLabel="NombreBodega"
          filter
          filterBy="NombreBodega"
          onChange={(e) => {
            setSelectedBodega(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (selected.some((s) => s.IdIngresoDetalle === detail.IdIngresoDetalle)) {
                  return {
                    ...detail,
                    IdBodega: e.value.IdBodega,
                    NombreBodega: e.value.NombreBodega,
                  };
                }
                return detail;
              });
  
              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
              );
              tempo2[index].IdBodega = e.value.IdBodega;
              tempo2[index].NombreBodega = e.value.NombreBodega;
              setDetalles(tempo2);
            }
  
            setResEst(true);
            setResPos(true);
            setResBand(true);
          }}
        />
      </div>
    );
  };
  
  const changeEstante = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={selectedEstante}
          options={filteredEstantes}
          style={{ width: "123px" }}
          optionLabel="NombreEstante"
          filter
          filterBy="NombreEstante"
          onChange={(e) => {
            setSelectedEstante(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (selected.some((s) => s.IdIngresoDetalle === detail.IdIngresoDetalle)) {
                  return {
                    ...detail,
                    IdEstante: e.value.IdEstante,
                    NombreEstante: e.value.NombreEstante,
                  };
                }
                return detail;
              });
  
              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
              );
              tempo2[index].IdEstante = e.value.IdEstante;
              tempo2[index].NombreEstante = e.value.NombreEstante;
              setDetalles(tempo2);
            }
              setResEst(true);
              setResPos(true);
              setResBand(true);
          }}
        />
      </div>
    );
  };
  
  const changePosicion = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={selectedPosicion}
          options={filteredPosiciones}
          style={{ width: "123px" }}
          optionLabel="NombrePosicion"
          filter
          filterBy="NombrePosicion"
          onChange={(e) => {
            setSelectedPosicion(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (selected.some((s) => s.IdIngresoDetalle === detail.IdIngresoDetalle)) {
                  return {
                    ...detail,
                    IdPosicion: e.value.IdPosicion,
                    NombrePosicion: e.value.NombrePosicion,
                  };
                }
                return detail;
              });
  
              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
              );
              tempo2[index].IdPosicion = e.value.IdPosicion;
              tempo2[index].NombrePosicion = e.value.NombrePosicion;
              setDetalles(tempo2);
              }
              setResEst(true);
              setResPos(true);
              setResBand(true);
          }}
        />
      </div>
    );
  };
  
  const changeBandeja = ({ data, oldValue, api }, column) => {
    return (
      <div>
        <Dropdown
          value={selectedBandeja}
          options={filteredBandejas}
          style={{ width: "123px" }}
          optionLabel="NombreBandeja"
          filter
          filterBy="NombreBandeja"
          // onChange={(e) => {
          //   setSelectedBandeja(e.value);
          //   let tempo2 = [...detalles];
          //   const index = detalles.findIndex(
          //     (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
          //   );
          //   tempo2[index].IdBandeja = e.value?.IdBandeja;
          //   tempo2[index].NombreBandeja = e.value.NombreBandeja;
          //   setDetalles(tempo2);
          // }}
          onChange={(e) => {
            setSelectedBandeja(e.value);
            if (selected.length > 0) {
              let detallesActualizados = detalles.map((detail) => {
                if (selected.some((s) => s.IdIngresoDetalle === detail.IdIngresoDetalle)) {
                  return {
                    ...detail,
                    IdBandeja: e.value.IdBandeja,
                    NombreBandeja: e.value.NombreBandeja,
                  };
                }
                return detail;
              });
  
              setDetalles(detallesActualizados);
              setSelected([]);
            } else {
              let tempo2 = [...detalles];
              const index = detalles.findIndex(
                (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
              );
              tempo2[index].IdBandeja = e.value.IdBandeja;
              tempo2[index].NombreBandeja = e.value.NombreBandeja;
              setDetalles(tempo2);
              }
              setResEst(true);
              setResPos(true);
              setResBand(true);
          }}
        />
      </div>
    );
  };

  const changeLote = ({ data }) => {
    return (
      <LotesOverlayPanel
        IdVendor={values?.CustomerName?.IdVendor}
        rowData={data}
        onChange={({ api, data }, rowData) => {
          const index = detalles.findIndex(
            (detail) => detail.IdLote === rowData.IdLote
          );

          const isAlreadyAdded = detalles.some(
            (detail) => detail.IdIngresoDetalle= data.IdIngresoDetalle);

          if (isAlreadyAdded) {
            toastShow(
              toast,
              "warn",
              "Advertencia",
              "El lote seleccionado ya existe en este pase de salida"
            );
            return;
          }
          let newDetail = [...detalles];
          newDetail[index].IdLote = data.IdLote;
          newDetail[index].NoLote = data.NoLote;
          newDetail[index].NoLoteInt = data.NoLoteInt;
          newDetail[index].CustomerName = data.CustomerName;
          setDetalles(newDetail);
          api.stopEditing();
        }}
      />
    );
  };

  const changeNoSacos = ({ data, column }) => {
    const index = detalles.findIndex(
      (detail) => detail.IdIngresoDetalle === data.IdIngresoDetalle
    );
    let newDetail = [...detalles];
    if (column.field === "NoSacos") {
      newDetail[index].NoSacos = data.NoSacos;
    }
    setDetalles(newDetail);
  };

  const calcularCantidad = (value, datosD, columna) => {
    let valor = value === undefined ? 0 : value
    let detalle

    handleChange(valor, "CostoL")
    detalle = datosD.data
    detalle.CostoL = valor
    detalle.MontoL = valor
    detalle.SubTotal = valor
    detalle.CostoD = valor / detalle?.TasaCambio
    detalle.MontoD = valor / detalle?.TasaCambio
    detalle.SubTotalD = valor * detalle?.TasaCambio

    if(detalle?.Ingreso > 0){
      detalle.PrecioD = valor / detalle?.Ingreso
      detalle.Precio = (valor * detalle?.TasaCambio) / detalle?.Ingreso
    }
        
    let tempo = detalles
    const index = tempo.findIndex(detail => detail?.IdIngresoDetalle === detalle?.IdIngresoDetalle)
    tempo[index] = detalle
  }

  const handleCheckboxChange = async (datos, e) => {
    const tieneISV = detalles.some((d) => d?.ISVProductoL);
    const tieneISV18 = detalles.some((d) => d?.ISV18ProductoL);
    
    if (!tieneISV && !tieneISV18 && !values?.OCE) {
      toastShow(toast, "error", "Error al guardar", "Debe ingresar OCE.");
      return;
    }

    if (datos) {
      // Asegurar que `datos` sea un array
      const detalles = Array.isArray(datos) ? datos : [datos];
      const idsIngresoDetalle = detalles.map((detalle) => detalle.IdIngresoDetalle);
  
      confirmDialog({
        message: `¿Está seguro que desea exentuar ${detalles.length > 1 ? "los detalles" : "el detalle"}?`,
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        accept: async () => {
          const datosTem = {
            IdIngresoDetalle: idsIngresoDetalle,
            IdUserExento: userAuth?.IdUser,
            OCE: values?.OCE,
            IdIngreso: values?.IdIngreso,
            IsExento : e
          };
  
            const respuestaDetalles = await cambiarExcentoDet(datosTem);
            
              toastShow(toast, "success", "Editado", "Registros actualizados.");
              obtenerIngreso();
        },
        reject: () => {},
      });
    }
  setSelected([]);
  };


  const changeIsExtenso = async (data, e) => {
      if(data?.IdIngresoDetalle > 0){

        const filteredSelected = selected?.filter((item) => !item.ISVProductoL && !item.ISV18ProductoL);

        if(filteredSelected?.length){
          handleCheckboxChange(filteredSelected, e)
        }else{
          handleCheckboxChange(data, e)
        }
      }else{
          setDetalles(detalles =>
              detalles.map(detail => {
                  if (detail.IdIngresoDetalle === data?.IdIngresoDetalle) {
                      let updatedDetail = { ...detail };
                      updatedDetail.IsExento = e;
                      return updatedDetail;
                  }
                  return detail;
              })
          );
      }
  }
  
  const TemplateConstruccion = ({ data, oldValue, api }, column) => {
    return <Dropdown
      value={data?.IdSubConstruccion}
      options={construcciones}
      optionValue='IdSubConstruccion'
      optionLabel='NombreCompuesto'
      filter filterBy='NombreCompuesto'

      style={{ width: '100%' }}
      onChange={(e) => {
        const tempoCo = construcciones.find((c) => c.IdSubConstruccion === e?.value)
        let tempo = [...detalles]
        let d = data
        if (tempoCo) {
          if (selected?.length > 0) {
            tempo.forEach((t) => {
              selected.forEach(s => {
                if (t.IdIngresoDetalle === s.IdIngresoDetalle) {
                  s.IdConstruccion = tempoCo?.IdConstruccion
                  s.IdSubConstruccion = tempoCo?.IdSubConstruccion
                  s.NombreCompuesto = tempoCo?.NombreCompuesto
                  // s.IdCuentaFinanzas = tempoCo?.IdCuenta
                  // s.CuentaFinanzas = tempoCo?.NombreCuenta
                }
              })
            });
          }
          if (d?.IdIngresoDetalle) {
            d.IdConstruccion = tempoCo?.IdConstruccion
            d.IdSubConstruccion = tempoCo?.IdSubConstruccion
            d.NombreCompuesto = tempoCo?.NombreCompuesto
            // d.IdCuentaFinanzas = tempoCo?.IdCuenta
            // d.CuentaFinanzas = tempoCo?.NombreCuenta

            const index = detalles.findIndex(detail => detail.IdIngresoDetalle === d.IdIngresoDetalle)
            tempo[index] = d
          }
        } else {
          d.IdConstruccion = null
          d.IdSubConstruccion = null
          d.NombreCompuesto = null
    

          const index = detalles.findIndex(detail => detail.IdIngresoDetalle === d.IdIngresoDetalle)
          tempo[index] = d
        }
        setSelected([])
        setDetalles(tempo)
      }}

      showClear

    />
  }

  const columns = [
    {
      header: "ID",
      headerEn: "ID",
      field: "IdIngresoDetalle",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Fecha Ingreso",
      headerEn: "Date Entry",
      field: "FechaIngreso",
      Format: "DateTime2",
      className: "small",
      frozen: true,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "medium",
      // editable: habilitar,
      // cellEditor: changeEstado,
      Format: "Estado",
      body: (rowData) => ({
        ID: rowData?.IdEstado,
        Estado: rowData?.StatusName,
      }),
    },
    {
      header: "No. Orden",
      headerEn: "No. Order",
      field: "PurchaseOrder",
      frozen: true,
      className: " small",
      // editable: habilitar,
      editable: (data) => {
        if(habilitar){
          if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
            return false;
          } else {
            return true;
          }
        }else{
          return false
        }
      },
      cellEditor: changePO,
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        setOrdenDialog(true)
        OrdenC(data.PurchaseOrder);
      },
      hidden: showPOColumn,
    },
    {
      header: "Código",
      headerEn: "Code",
      field: "CodigoProducto",
      className: "Xsmall"
    },
    {
      header: "Producto",
      headerEn: "Product",
      cellEditor: changeProducto,
      // editable: !showPOColumn && habilitar,
      editable: (data) => {
        if (!showPOColumn && habilitar) {
          if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
            return false; 
          } else {
            return true;
          }
        }
        return false;
      },
      field: "NombreProducto",
      className: "XXlarge"
    },
    {
      header: "Descripción",
      headerEn: "Description",
      field: "Descripcion",
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "small"
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "small"
    },
    !serviciosNuevo ?
    {
      header: "Sub Categoría",
      headerEn: "SubCategory",
      field: "NombreTipoProducto",
      className: "medium"
    } : null,
    !serviciosNuevo ?
    {
      header: "Unidad",
      headerEn: "Unit",
      field: "UnitName",
      className: "medium"
    } : null,
    !serviciosNuevo ?
    {
      field: "NombreBodega",
      header: "Bodega",
      headerEn: "Warehouse",
      className: "large",
      body: (rowData) => rowData.NombreBodega,
      cellEditor: changeBodega,
      // editable: habilitar,
      editable: (data) => {
        if(habilitar){
        if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
          return false;
        } else {
          return true;
        }
      }else{
        return false
      }}
    } : null,
    !serviciosNuevo ?
    {
      field: "NombreEstante",
      header: "Estante",
      className: "small",
      body: (rowData) => rowData.NombreEstante,
      cellEditor: changeEstante,
      // editable: habilitar,
      editable: (data) => {
        if(habilitar){
        if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
          return false;
        } else {
          return true;
        }
      }else{
        return false
      }}
    }: null,
    !serviciosNuevo ?
    {
      field: "NombrePosicion",
      header: "Fila",
      className: "small",
      body: (rowData) => rowData.NombrePosicion,
      cellEditor: changePosicion,
      // editable: habilitar,
      editable: (data) => {
        if(habilitar){
        if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
          return false;
        } else {
          return true;
        }
      }else{
        return false
      }}
    } : null,
    !serviciosNuevo ?
    {
      field: "NombreBandeja",
      header: "Bandeja",
      className: "small",
      body: (rowData) => rowData.NombreBandeja,
      cellEditor: changeBandeja,
      // editable: habilitar,
      editable: (data) => {
        if(habilitar){
        if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
          return false;
        } else {
          return true;
        }
      }else{
        return false
      }}
    } : null,
    {
      header: "Solicitado",
      headerEn: "Type",
      Sumary: "sum",
      field: "Quantity",
      Format: "Currency",
      className: "Xsmall",
      hidden: showPOColumn,

    },
    {
      header: "Ingresado",
      headerEn: "Ingresado",
      field: "QtyReceive",
      Sumary: "sum",
      Format: "Currency",
      className: "Xsmall",
    },
    serviciosNuevo ?
    {
      header: "Balance PO",
      headerEn: "Balance PO",
      field: "BalanceReservado",
      Sumary: "sum",
      Format: "Currency",
      frozen: true,
      className: "Xsmall",
      hidden: showPOColumn,
    } : 
    {
      header: "Balance PO",
      headerEn: "Balance PO",
      field: "Balance",
      Sumary: "sum",
      Format: "Currency",
      frozen: true,
      className: "Xsmall",
      hidden: showPOColumn,
    },
    //Es Exento
    {
      field: 'IsExento',
      header: 'Exento',
      className: "Xsmall",
      Format: "Template",
      align: "center",
      frozen: "true",
      alignFrozen: "right",
      filter: false,
      body: (rowData) =>  rowData?.IdIngresoDetalle && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>          
            <Checkbox 
            onChange={(e) => {
              changeIsExtenso(rowData, e.checked)}
            }
            disabled={!habilitar || !!rowData?.ISVProductoL || !!rowData?.ISV18ProductoL}
            checked={rowData.IsExento} />
        </div>
      ),
    },
    
    serviciosNuevo ?
    {
      header: "Ingreso",
      headerEn: "Income",
      field: "CantidadReservada",
      editable: (data) => {
        if (habilitar) {
          if (data.data.BalanceReservado === data.data.CantidadReservada && data.data.IdIngresoDetalle > 0) {
            return false;
          } else {
            return true;
          }
        }
      },
      // bodyComponent: (props) => <InputIngreso datosD={props} />,
      onChange: (data) => changeIngreso(data),
      Sumary: "sum",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right",
      className: "Xsmall",
    } : 
    {
      header: "Ingreso",
      headerEn: "Income",
      field: "Ingreso",
      editable: (data) => {
        if (habilitar) {
          if (data.data.Balance < data.data.Ingreso && data.data.IdIngresoDetalle > 0) {
            return false;
          } else {
            return true;
          }
        }
      },
      // bodyComponent: (props) => <InputIngreso datosD={props} />,
      onChange: (data) => changeIngreso(data),
      Sumary: "sum",
      Format: "Currency",
      frozen: true,
      alignFrozen: "right",
      className: "Xsmall",
    }, ,  
    {
      header: "Inventario",
      headerEn: "Inventory",
      Sumary: "sum",
      field: "Inventario",
      hidden: userAuth.IdRol === 1,
      Format: "Currency",
      className: "Xsmall",
    },
    {
      header: "Moneda",
      headerEn: "Currency",
      field: "Currency",
      className: "Xsmall"
    },
    {
      field: "NoLote",
      hidden: isMateriaPrima,
      header: "Lote",
      headerEn: "Lote",
      className: "medium",
      editable: habilitar,
      cellEditor: changeLote,
    },
    {
      header: "No. Sacos",
      headerEn: "No. Sacos",
      field: "NoSacos",
      Format: "Currency",
      onChange: (data) => changeNoSacos(data),
      editable: habilitar,
      hidden: isMateriaPrima,
      className: "medium"
    },
    {
      header: "No. Lote Interno",
      headerEn: "No. Lote Interno",
      field: "NoLoteInt",
      hidden: userAuth.IdRol === 1 && isMateriaPrima,
      className: "medium"
    },
    {
      header: "Fecha Obsoleto",
      headerEn: "Date Obsolete",
      field: "FechaObsoleto",
      className: "large",
      hidden: isMateriaPrima,
      editable: habilitar,
      align: "center",
      Format: "DateDisabled",
    },
    {
      field: "TasaCambio",
      header: "Tasa Cambio",
      headerEn: "Exchange Rate",
      Format: "Decimal",
      Sumary: "sum",
      className: "Xsmall",
    },
    // serviciosNuevo ? 
    // {
    //   field: 'NombreConstruccion',
    //   header: 'Construcción',
    //   headerEn: 'Construcción',
    //   className: 'XXlarge',
    //   editable: habilitar,
    //   onChange: ({ state, data: rowData, value, label, api, items, oldValue }) => {
    //     let row = { ...rowData }
    //     let tempo = [...detalles]
    //     if (state?.IdConstruccion !== oldValue?.IdConstruccion) {
    //       if (selected.length > 0) {
    //         tempo.forEach((t) => {
    //           selected.forEach((s) => {
    //             if (t.IdIngresoDetalle === s.IdIngresoDetalle) {
    //               s.IdConstruccion = state?.IdConstruccion
    //               s.NombreConstruccion = state?.NombreConstruccion
    //               s.IdSubConstruccion = state?.IdSubConstruccion
    //             }
    //           })
    //         })
    //       }
    //       if (row.IdIngresoDetalle) {
    //         row.IdConstruccion = state?.IdConstruccion
    //         row.NombreConstruccion = state?.NombreConstruccion
    //         row.IdSubConstruccion = state?.IdSubConstruccion

    //         const index = detalles.findIndex((detail) => detail.IdIngresoDetalle === row.IdIngresoDetalle)
    //         tempo[index] = row
    //       }
    //     } else {
    //       return
    //     }
    //     setSelected([])
    //     setDetalles(tempo)
    //   },
    //   width: 250,
    //   filter: true,
    //   value: 'IdConstruccion',
    //   label: 'NombreConstruccion',
    //   items: construcciones,
    //   Format: 'AutoComplete',
    //   flex: 1,
    //   minWidth: 500
    // }: null,


    serviciosNuevo ? 
      {
        field: 'NombreCompuesto',
        header: 'Construcción',
        headerEn: 'Construccion',
        className: 'XXXlarge',
        editable: habilitar,
        cellEditor: TemplateConstruccion
      } : null,
    {
      field: 'NombreCuenta',
      header: 'Cuenta',
      headerEn: 'Account',
      className: 'XXlarge',
      editable: habilitar,
      onChange: ({ state, data: rowData, value, api, items, oldValue }) => {
        let row = { ...rowData }
        let tempo = [...detalles]
        if (state?.IdAccount !== oldValue?.IdAccount) {
          if (selected.length > 0) {
            tempo.forEach((t) => {
              selected.forEach((s) => {
                if (t.IdIngresoDetalle === s.IdIngresoDetalle) {
                  s.IdAccount = state?.IdAccount
                  s.NombreCuenta = state?.NombreCuenta
                }
              })
            })
          }
          if (row.IdIngresoDetalle) {
            row.IdAccount = state?.IdAccount
            row.NombreCuenta = state?.NombreCuenta

            const index = detalles.findIndex((detail) => detail.IdIngresoDetalle === row.IdIngresoDetalle)
            tempo[index] = row
          }
        } else {
          return
        }
        setSelected([])
        setDetalles(tempo)
      },
      width: 250,
      filter: true,
      value: 'IdAccount',
      label: 'NombreCuenta',
      items: cuentas2,
      Format: 'AutoComplete',
      flex: 1,
      minWidth: 500
    },

    //EMBALAJE
    {
      headerName: 'Embalaje',
      children: [          
        {
          field: "EmbalajeL",
          header: "Monto L",
          Sumary: "sum",
          headerEn: "Monto L",
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
        {
          field: "EmbalajeD",
          header: "Monto $",
          Sumary: "sum",
          headerEn: "Monto $",      
          hidden: verCostos || verCostosBodega,
          Format: "Currency",
          className: "small",
        },
      ]
    },
    //DESADUANAJE
    {
      headerName: 'Desaduanaje',
      children: [
        {
          field: "DesaduanajeL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "DesaduanajeD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ]
    },
    // FLETE
    {
      headerName: 'Flete',
      children: [          
        {
          field: "FleteL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "FleteD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ]
    },
    // OTROS COSTOS
    {
      headerName: 'Otros Costos',
      children: [          
        {
          field: "OtrosCostosL",
          header: "Monto L",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto L",
          Format: "Currency",
          className: "small",
        },
        {
          field: "OtrosCostosD",
          header: "Monto $",
          Sumary: "sum",
          hidden: verCostos || verCostosBodega,
          headerEn: "Monto $",
          Format: "Currency",
          className: "small",
        },
      ]
    },

    // LEMPIRAS
    {
      headerName: 'Lempiras',
      children: [          
        {
          header: "PrecioL",
          Sumary: "sum",
          headerEn: "PriceL",
          field: "Precio",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Format: "Currency",
          onChange: (data) => changePrecio(data),
          className: "Xsmall",
          editable: (data) => {
            if (habilitar) {
              if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
                return false; 
              } else {
                return true;
              }
            }
            return false;
          },
        },
        {
          header: "Sub Total L",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "Sub Total L",
          Sumary: "sum",
          onChange: (data) => changePrecio(data),
          field: "SubTotal",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "ISV L",
          Sumary: "sum",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "TAX L",
          field: "ISVProductoL",
          Format: "Currency",
          // onChange: (data) => changeISV(data),
          onChange: (data) => changePrecio(data),
          className: "Xsmall",
          // editable: !showPOColumn && habilitar,
          editable: (data) => {
            if (!showPOColumn && habilitar) {
              if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
                return false; 
              } else {
                return true;
              }
            }
            return false;
          },
        },
        {
          header: "ISV 18 L",
          Sumary: "sum",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "TAX 18 L",
          field: "ISV18ProductoL",
          Format: "Currency",
          // onChange: (data) => changeISV(data),
          onChange: (data) => changePrecio(data),
          className: "Xsmall",
          editable: false,
          // editable: (data) => {
          //   if (!showPOColumn && habilitar) {
          //     if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
          //       return false; 
          //     } else {
          //       return true;
          //     }
          //   }
          //   return false;
          // },
        },
        {
          header: "Desc. L",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "Disc. L",
          // editable: !showPOColumn && habilitar,
          editable: (data) => {
            if (!showPOColumn && habilitar) {
              if (data.data.Inventario < data.data.Ingreso && data.data?.IdIngresoDetalle > 0) {
                return false; 
              } else {
                return true;
              }
            }
            return false;
          },
          field: "Descuento",
          onChange: (data) => changePrecio(data),
          Sumary:"sum",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "MontoL",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "MontoL",
          // onChange: (data) => changePrecio(data),
          field: "MontoL",
          Format: "Currency",
          Sumary: "sum",
          className: "small",
        },
      ]
    },

    {
      header: "CostoL",
      headerEn: "CostoL",
      // onChange: (data) => changePrecio(data),
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      field: "CostoL",
      // cellEditor: (data) => <InputCostoL datosD={data}/>,
      Format: "Currency",
      // editable: !showPOColumn,
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right",
      className: "small",
    },
    
    // DOLARES 
    {
      headerName: 'Dolares',
      children: [
        {
          header: "Precio $",
          Sumary: "sum",
          headerEn: "Price $",
          field: "PrecioD",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Format: "Currency",
          // onChange: (data) => changePrecio(data),
          className: "Xsmall",
          // editable: !showPOColumn && habilitar,
        },
        {
          header: "Sub Total $",
          headerEn: "Sub Total $",
          Sumary: "sum",
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          onChange: (data) => changePrecio(data),
          field: "SubTotalD",
          Format: "Currency",
          className: "Xsmall",
        },
        {
          header: "ISV $",
          // onChange: (data) => changePrecio(data),
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "TAX $",
          Sumary: "sum",
          field: "ISVProductoD",
          Format: "Currency",
          className: "Xsmall",
          // editable: !showPOColumn && habilitar,
        },
        {
          header: "ISV 18% $",
          // onChange: (data) => changePrecio(data),
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          headerEn: "TAX 18% $",
          Sumary: "sum",
          field: "ISV18ProductoD",
          Format: "Currency",
          className: "Xsmall",
          // editable: !showPOColumn && habilitar,
        },
        {
          header: "Desc. $",
          headerEn: "Disc. $",
          // editable: !showPOColumn && habilitar,
          field: "DescuentoD",
          // onChange: (data) => changePrecio(data),
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          Sumary:"sum",
          Format: "Currency",
          className: "Xsmall",
        },

        {
          header: "Monto $",
          headerEn: "Monto $",
          // onChange: (data) => changePrecio(data),
          hidden: userAuth.IdRol === 1,
          hidden: hiddenPriceColumn,
          field: "MontoD",
          Format: "Currency",
          Sumary: "sum",
          className: "small",
        },
      ]
    },

    {
      header: "Costo $",
      headerEn: "Costo $",
      // onChange: (data) => changePrecio(data),
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      field: "CostoD",
      Format: "Currency",
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right",
      className: "small",
    },


    {
      header: "PrecioUL",
      Sumary: "sum",
      headerEn: "PriceUL",
      field: "PrecioUL",
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },

    {
      header: "PrecioUD",
      Sumary: "sum",
      headerEn: "PriceUD",
      field: "PrecioUD",
      hidden: userAuth.IdRol === 1,
      hidden: hiddenPriceColumn,
      Format: "Currency",
      className: "Xsmall",
    },
  ];

  const table = {
    Columns: columns,
    Data: detalles,
    selected: selected,
    setSelected: setSelected,
    showModal: (e) => showModal(e),
  };

  const cambiarValores = () => {
    if (detalles.length > 0) {
      let newDetails = detalles.map((detail) => {
        const ingreso = serviciosNuevo ? detail?.CantidadReservada ?? 0 : detail.Ingreso ?? 0;
        const precio = detail.Precio ?? 0;
        const tasaCambio = values.TasaCambio ?? 1;
        const isvProducto = detail.ISVProducto ?? 0;
        const descuentoProducto = detail.DescuentoProducto ?? 0;
  
        const subTotalL = detail.IdCurrency === 1 ? (precio * ingreso) * tasaCambio : precio * ingreso;
        const subTotalD = detail.IdCurrency === 1 ? precio * ingreso : (precio * ingreso) / tasaCambio;

        const isvProductoL = detail.IdCurrency === 1 ? (isvProducto * tasaCambio) * ingreso : isvProducto * ingreso;
        const isvProductoD = detail.IdCurrency === 1 ? isvProducto * ingreso : (isvProducto / tasaCambio) * ingreso;
  
        const descuentoL = detail.IdCurrency === 1 ? descuentoProducto * tasaCambio : descuentoProducto;
        const descuentoD = detail.IdCurrency === 1 ? descuentoProducto : descuentoProducto / tasaCambio;
  
        const montoL = subTotalL + isvProductoL - descuentoL;
        const montoD = subTotalD + isvProductoD - descuentoD;
  
        const costoL = montoL; 
        const costoD = montoD; 
        
  
        return {
          ...detail,
          SubTotal: subTotalL,
          SubTotalD: subTotalD,
          ISVProductoL: isvProductoL,
          ISVProductoD: isvProductoD,
          Descuento: descuentoL,
          DescuentoD: descuentoD,
          MontoL: montoL,
          MontoD: montoD,
          CostoL: costoL,
          CostoD: costoD,
          TasaCambio: tasaCambio
        };
      });
  
      setDetalles(newDetails);
    }
  };

  const AsignarCuentaEnTransito = async (e) => {
    setHabilitar(true)
    if(desdeDropdown){
      console.log(values?.CuentaConcatenadaCont?.IdAccount)
      let IdCuenta = values?.CuentaConcatenadaCont?.IdAccount
      let IdCuentaTransito = e?.IdIngreso
      let IdIngreso = values?.IdIngreso
      const resp = await asignarCuentaEnTransito({IdCuenta, IdCuentaTransito, IdIngreso})
      toastShow(toast, 'success', 'Cuenta asignada', 'se guardo el ingreso con la cuenta en transito seleccionda.')
      obtenerIngreso()
    }else{
      toastShow(toast, 'success', 'Cuenta asignada', 'Guarde el registro para finalizar la asiganción')
      setValues({
        ...values,
        IdCuentaTransito: e?.IdIngreso,
        IdCuenta: null,
        CuentaConcatenadaCont: '',
      })
    }
  }
  
  const showModal = () => {
    setOrdenDialog(true);
  };

  const OrdenC = (Id) => {
    setOrderToShow(Id);
    setOrdenDialog(true);
    showModal();
  };

  useEffect(() => {
    getInfo();
    setDetalles([]);
    if (idIngreso) {
      obtenerIngreso();
    } else {
      getInfoNew();
    }
  }, [idIngreso]);

  useEffect(() => {
    if(values?.CustomerName?.IdVendor){
      obtenerCAI(values?.CustomerName?.IdVendor)
    }
  }, [values?.CustomerName?.IdVendor]);


  useEffect(() => {
    if(values?.NombreSucursal){
      if(!values?.Factura){
        setValues({
          ...values,
          Factura: values?.NombreSucursal?.Prefijo,
        })
      }
    }
  }, [values?.NombreSucursal]);

  useEffect(() => {
    if (selectedBodega) {
      const filteredEstantes = estantes.filter(e => e.IdBodega === selectedBodega.IdBodega);
      setFilteredEstantes(filteredEstantes);
      setSelectedEstante(null); 
      setSelectedPosicion(null); 
      setFilteredPosiciones([]);
      setFilteredBandejas([]);
    } else {
      setFilteredEstantes(estantes);
    }
  }, [selectedBodega]);
  
  useEffect(() => {
    if (selectedEstante) {
      const filteredPosiciones = posicion.filter(p => p.IdEstante === selectedEstante.IdEstante);
      setFilteredPosiciones(filteredPosiciones);
      setSelectedPosicion(null);
      setFilteredBandejas([]);
    } else {
      setFilteredPosiciones(posicion);
    }
  }, [selectedEstante]);

  useEffect(() => {
    if (selectedPosicion) {
      const filteredBandejas = bandeja.filter(b => b.IdPosicion === selectedPosicion.IdPosicion);
      setFilteredBandejas(filteredBandejas);
    } else {
      setFilteredBandejas(bandeja);
    }
  }, [selectedPosicion]);

  useEffect(() => {
    if (selectedBodega) {
      const updatedDetalles = [...detalles].map(detail => {
        const index = detalles.findIndex(
          (d) => d.IdIngresoDetalle === detail.IdIngresoDetalle
        );
        if (index !== -1 && detalles[index].IdBodega === selectedBodega.IdBodega) {
          if(resEst){
            let updatedDetail = { ...detalles[index] };
            updatedDetail.IdEstante = null;
            updatedDetail.NombreEstante = "";
            updatedDetail.IdPosicion = null;
            updatedDetail.NombrePosicion = "";
            updatedDetail.IdBandeja = null;
            updatedDetail.NombreBandeja = "";
            return updatedDetail;
          }
        }
        return detail;
      });
      setDetalles(updatedDetalles);
    }
  }, [selectedBodega]);
  
  useEffect(() => {
    if (selectedEstante) {
      const updatedDetalles = [...detalles].map(detail => {
        const index = detalles.findIndex(
          (d) => d.IdIngresoDetalle === detail.IdIngresoDetalle
        );
        if (index !== -1 && detalles[index].IdEstante === selectedEstante.IdEstante) {
          if(resPos){
            let updatedDetail = { ...detalles[index] };
            updatedDetail.IdPosicion = null;
            updatedDetail.NombrePosicion = "";
            updatedDetail.IdBandeja = null;
            updatedDetail.NombreBandeja = "";
            return updatedDetail;
          }
        }
        return detail;
      });
      setDetalles(updatedDetalles);
    }
  }, [selectedEstante, resPos]);
  
  useEffect(() => {
    if (selectedPosicion) {
      const updatedDetalles = [...detalles].map(detail => {
        const index = detalles.findIndex(
          (d) => d.IdIngresoDetalle === detail.IdIngresoDetalle
        );
        if (index !== -1 && detalles[index].IdPosicion === selectedPosicion.IdPosicion) {
          if(resBand){
            let updatedDetail = { ...detalles[index] };
            updatedDetail.IdBandeja = null;
            updatedDetail.NombreBandeja = "";
            return updatedDetail;
          }
        }
        return detail;
      });
      setDetalles(updatedDetalles);
    }
  }, [selectedPosicion, resBand]);

  useEffect(() => {
    cambiarValores()
  }, [values?.TasaCambio]);

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && orderToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setRequisaDialog(null);
          setOrdenDialog(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setRequisaDialog(null);
      setOrdenDialog(null);
      setHabilitar(true);
    }
  };

  const abrirTransito = async(IdPurchaseOrder) => {
    const dataTransito = await getOrdenesEnTransito(IdPurchaseOrder)
    if(dataTransito?.length > 0){
      toastShow(toast, 'warn', 'Advertencia','La orden de compra tiene cuenta en transito')
      setDataTransito(dataTransito)
      setDesdeDropdown(true)
      setDialogTransito(true)
    }
  }

  useEffect(() => {
    if(values?.CuentaConcatenadaCont?.IdAccount){
      if(!values?.IdCuentaTransito){
        if(values?.CuentaConcatenadaCont?.IdAccount !== 15){
          if(values?.CuentaConcatenadaCont?.IdAccount !== 16){
            if(values?.CuentaConcatenadaCont?.IdAccount !== 14){
            if(values?.IdPurchaseOrder){
                abrirTransito(values?.IdPurchaseOrder)
              }
            }
          }
        }
      }
    }
  }, [values?.CuentaConcatenadaCont?.IdAccount]);

  return (
    <div>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <EncabezadoIngresos
        values={values}
        detalles={detalles}
        handleInputChange={handleInputChange}
        handleChange={handleChange}
        setHabilitar={setHabilitar}
        toast={toast}
        resetForm={resetForm}
        setDetalles={setDetalles}
        getIngreso={obtenerIngreso}
        habilitar={habilitar}
        setValues={setValues}
        setIngresoToShow={setIngresoToShow}
        proveedor={proveedor}
        agregarNuevaFila={agregarNuevaFila}
        eliminarItemDetalle={eliminarItemDetalle}
        guardarIngresosBodega={guardarIngresosBodega}
        guardarIngresos={guardarIngresos}
        addOC={addOC}
        listadoDet={listadoDet}
        setShowPOColumn={setShowPOColumn}
        showPOColumn={showPOColumn}
        hab ={hab}
        setHab={setHab}
        term={term}
        proveedorCAI={proveedorCAI}
        checkDollar={checkDollar}
        setCheckDollar={setCheckDollar}
        setLoading={setLoading}
        setVerCostosBodega={setVerCostosBodega}
        verCostosBodega={verCostosBodega}
        isMateriaPrima={isMateriaPrima}
        setIsMateriaPrima={setIsMateriaPrima}
        MateriaPrima={MateriaPrima}
        tiposIngreso={tiposIngreso}
        addSingleOC={addSingleOC}
        Servicios={Servicios}
        reg={reg}
        listEstados={listEstados}
        cuentas={cuentas}
        serviciosNuevo={serviciosNuevo}
        selectedDet={selected}
      ></EncabezadoIngresos>
      <Card
        contenido={
          <div style={{ height: "56vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />


      <div className="mt-2" style={{ textAlign: "right", marginRight: 10 }}>
        <p style={{ marginBottom: "1px", fontSize: 14}}>
          <strong>Usuario Creación:</strong> {userAuth?.UserName}
        </p>
        <p style={{ marginBottom: "1px", fontSize: 14 }}>
          <strong>Fecha Creación:</strong> {values?.FechaIngreso ? new Date(values.FechaIngreso).toLocaleDateString() : ""}
        </p>
        {values?.UserNameEdit && (
          <p style={{ marginBottom: "1px", fontSize: 14 }}>
            <strong>Usuario Edición:</strong> {values?.UserNameEdit}
          </p>
        )}
        {values?.FechaEditStr && (
          <p style={{ marginBottom: "1px", fontSize: 14 }}>
            <strong>Fecha Edición:</strong> {new Date(values.FechaEditStr).toLocaleDateString()}
          </p>
        )}
      </div>



      <ModalFull
        header="Orden de compras"
        visible={ordenDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        contenido={
          <OrdenesComprasCrud
            PurchaseOrder={orderToShow}
            setOrderToShow={setOrderToShow}
            ordenDialog={ordenDialog}
            setOrdenDialog={setOrdenDialog}
            setRequisaDialog={setRequisaDialog}
            infoScreen={getInfo}
            habilitar={habilitar}
            setHabilitar={setHabilitar}
          />
        }
      />

      {dialogTransito && (
        <ModalCuentasEnTransito
          showDialog={dialogTransito}
          setShowDialog={setDialogTransito}
          data={dataTransito}
          AsignarCuentaEnTransito={AsignarCuentaEnTransito}
        />
      )}

      

    </div>
  );
};

export default RegistroFactrasCRUD;